export const tableHeader = (t) => [
  {
    id: 'name',
    type: 'text',
    value: t('user:users.table.name'),
  },
  {
    id: 'email',
    type: 'text',
    value: t('user:users.table.email'),
  },
  {
    id: 'active',
    type: 'boolean',
    value: t('user:users.table.active'),
  },
  {
    id: 'action',
    type: 'actions-status',
    value: '',
  },
]
